<template>
  <div class="topic-deck">
    <TopicCard
      v-for="(topic, index) in topics"
      :key="index"
      :index="index"
      :title="topic.title"
      :image="topic.image"
      :description="topic.description"
      class="topic-card-fixed"
    />
  </div>
</template>

<script>
import TopicCard from './TopicCard';
import { topics } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'TopicDeck',
  components: {
    TopicCard
  },
  data() {
    return {
      topics: topics
    };
  }
};
</script>

<style scoped>
.topic-deck {
  display: flex;
  gap: 4px;
}

/* 화면 너비 1200px 이하에서 2x2 배열 적용 */
@media (max-width: 1200px) {
  .topic-deck {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }
}

/* 화면 너비 768px 이하에서 1x4 세로 배열 */
@media (max-width: 768px) {
  .topic-deck {
    display: grid;
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

.topic-card-fixed {
  flex: 1;
}
</style>
